/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_PassedInputs */

const en_player_passed = /** @type {(inputs: Player_PassedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passed!`)
};

const ja_player_passed = /** @type {(inputs: Player_PassedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合格!`)
};

const fr_player_passed = /** @type {(inputs: Player_PassedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réussi !`)
};

const de_player_passed = /** @type {(inputs: Player_PassedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestanden!`)
};

/**
* | output |
* | --- |
* | "Passed!" |
*
* @param {Player_PassedInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_passed = /** @type {((inputs?: Player_PassedInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_PassedInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_passed(inputs)
	if (locale === "ja") return ja_player_passed(inputs)
	if (locale === "fr") return fr_player_passed(inputs)
	return de_player_passed(inputs)
});